<script setup lang="ts">
import type { Currency } from '~/types/api'

const props = defineProps<{
  price: number
  showPrices: boolean
  currency: Currency
}>()

const count = defineModel<number>()
</script>

<template>
  <div class="flex flex-col gap-5">
    <div class="flex justify-between">
      <p
        v-if="props.showPrices"
        class="font-pragmatica-ext whitespace-nowrap font-bold 2xl:text-lg"
      >
        {{ $t('configurator.configurationPrice') }}
      </p>
      <div v-if="props.showPrices" class="pl-2 pr-5">
        <p
          class="font-pragmatica-ext justify-self-center font-bold 2xl:text-lg"
        >
          {{ formatPrice(props.price, props.currency) }}
          <span class="font-sans text-sm font-normal">
            {{ $t('base.order.withoutVat') }}
          </span>
        </p>
        <!-- <p
          v-if="props.showPrices"
          class="justify-self-end text-sm 2xl:text-base"
        >
          {{
            formatPrice(priceWithVat(props.price), props.currency) +
            ' ' +
            $t('configurator.withVat')
          }}
        </p> -->
      </div>
    </div>
    <div class="flex justify-between">
      <p class="font-pragmatica-ext whitespace-nowrap font-bold 2xl:text-lg">
        {{ $t('configurator.count') }}
      </p>
      <div class="pl-2 pr-5">
        <ProductConfiguratorCounter
          v-model="count"
          class="justify-self-center"
          :class="{
            '!justify-self-end': !props.showPrices,
          }"
        />
      </div>
    </div>
    <div class="flex justify-between">
      <p
        v-if="props.showPrices"
        class="font-pragmatica-ext whitespace-nowrap font-bold 2xl:text-lg"
      >
        {{ $t('configurator.totalPrice') }}
      </p>
      <div v-if="props.showPrices" class="pl-2 pr-5">
        <p
          class="font-pragmatica-ext justify-self-center font-bold 2xl:text-lg"
        >
          {{ formatPrice(props.price * count, props.currency) }}
          <span class="font-sans text-sm font-normal">
            {{ $t('base.order.withoutVat') }}
          </span>
        </p>
        <!-- <p class="justify-self-end text-sm 2xl:text-base">
          {{
            formatPrice(priceWithVat(props.price, count), props.currency) +
            ' ' +
            $t('configurator.withVat')
          }}
        </p> -->
      </div>
    </div>
  </div>
</template>
